module.exports = __webpack_public_path__ + "static/media/logo_comune.5a056547.png";